<template>
  <div class='app-container'>
    <el-card class='box-card'>
      <div slot='header' class='clearfix'>
        <span>批量生码</span>
      </div>
      <div class='QRCode' style='display: none' ref='qrCodeUrl'></div>

      <el-form :label-width='formLabelWidth' ref='form' :rules='rules' :model='form'>
        <el-form-item label='生码规则' prop='type'>
          <el-select v-model='form.type' placeholder='请选择生码规则' @change='typeChange' style='width:50%;'>
            <el-option
              v-for='item in type_options'
              :key='item.id'
              :label='item.label'
              :value='item.value'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='网址前缀' prop='path'>
          <el-input t v-model='form.path' placeholder='请输入网址前缀' style='width:50%;'></el-input>
        </el-form-item>
        <el-form-item label='序列编号' v-if='form.type==2' prop='code'>
          <el-input t v-model='form.code' placeholder='请输入序列编号' style='width:50%;'></el-input>
        </el-form-item>
        <el-form-item label='生成数量' v-if='form.type!=3' prop='total'>
          <el-input t v-model='form.total' placeholder='请输入生成数量' style='width:50%;'></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type='primary' @click='create'>生成</el-button>
          <el-button @click='reset'>重置</el-button>
          <el-button size='small' v-if='ids.length==form.total' type='primary' @click='createQrCode'>下载二维码</el-button>
          <el-button size='small' v-if='ids.length==form.total' type='primary' @click='outExcel'>导出excel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { gateway } from '@/api/admin.js'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'

import FileSaver from 'file-saver'
import JSZip from 'jszip'
import QRCode from 'qrcodejs2'
import { xlsx } from '@/utils/xlsx'

export default {
  data() {
    return {
      ids: [],
      QRCodeURL: [],            //存放生成的二维码图片地址
      loading: false,
      timer: null,
      formLabelWidth: '100px',
      form: {
        code: 1,
        total: 1,
        path: this.$global.URL.socket,
        count: 0,
        base64QRCode: '',
        type: 2
      },
      type_options: [{ label: '按UUID生码', value: 1 }, { label: '按序号递增生码', value: 2 }, { label: '网址前缀+自定义', value: 3 }],
      rules: {
        type: [
          { required: true, message: '请选择生码规则', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入序列编号', trigger: 'blur' }
        ],
        total: [
          { required: true, message: '请输入生成数量', trigger: 'blur' }
        ],
        path: [
          { required: true, message: '请输入网址前缀', trigger: 'blur' }
        ]
      },
      list: {
        id: '序号',
        name: '二维码内容',
      }
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.id = this.$route.query.id
  },
  methods: {
    //重置输入框
    reset() {
      this.form = {
        code: 1,
        total: 1,
        count: 0,
        path: '',
        base64QRCode: '',
        type: 2
      }
      this.ids = []
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },

    typeChange() {
      this.form.total = 1
    },
    //生成二维码
    create() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.ids = []
          let total = parseInt(this.form.total)

          //构建 唯一字符串，加到数组ids里面
          if (this.form.type == 1) {
            //按UUID 生码
            for (let i = 0; i < total; i++) {
              let id = uuidv4()
              this.ids.push(this.form.path + id.split('-').join('').toUpperCase())
            }
          } else if (this.form.type ==2) {
            //按 序列号 生码
            let code = parseInt(this.form.code)
            for (let i = 0; i < total; i++) {
              this.form.code = code + i
              this.ids.push(this.form.path + this.form.code)
            }
          }else{
            this.ids.push(this.form.path)
          }
          this.createQrCode()
        } else {
          return false
        }
      })
    },

    // 生成二维码
    createQrCode() {

      if (!this.ids.length) return
      document.querySelector('.QRCode').innerHTML = ''  // 清空div中的二维码图片
      this.ids.forEach((each) => {                       // 循环创建二维码
        new QRCode(this.$refs.qrCodeUrl, {             // 将创建好的二维码图片放在div中
          text: each,                                  // 需要转换为二维码的内容
          width: 720,
          height: 720,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })





      let a = new Promise((resolve) => {
        setTimeout(() => {
          this.QRCodeURL = []
          document.querySelectorAll('.QRCode img').forEach((each) => { // 查找div中的二维码图片
            this.QRCodeURL.push(each.src)                             // 保存创建的二维码图片地址
          })
          return resolve()
        }, 5000)
      })

      a.then(() => {
        this.batchQrCodeZip()                                      // 下载打包二维码图片
      })
    },

    batchQrCodeZip() {
      const zip = new JSZip()        //新建一个压缩文件
      const _this = this
      const promises = []
      for (const key in this.QRCodeURL) {
        const promise = _this.getFile(this.QRCodeURL[key]).then(data => { // 根据二维码图片地址下载文件, 并存成ArrayBuffer对象
          // console.log(this.QRCodeURL[key])
          zip.file(`${this.ids[key]}` + '.png', data, { binary: true })           // 逐个添加文件，需要加后缀".png"
        })
        promises.push(promise)
      }

      Promise.all(promises).then(() => {
        zip.generateAsync({ type: 'blob' })
          .then(content => {
            // 生成二进制流
            var time= new Date().getTime()
            FileSaver.saveAs(content, '二维码'+time) // 利用file-saver保存文件  自定义文件名
          })
      })
        .catch(res => {
          console.log(res)
        })
    },

    // 根据二维码图片地址下载二维码
    getFile(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'blob'
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error.toString())
        })
      })
    },
    outExcel() {
      var jsonArray = []
      var time= new Date().getTime()
      for (let i = 0; i < this.ids.length; i++) {
        jsonArray.push({ id: i+1 , name: this.ids[i] })
      }
      xlsx(jsonArray, this.list, '批量生码'+time)
    }
  }
}
</script>

<style scoped>

</style>